export default "__VITE_ASSET__D9AwH$Fx__"